<script setup lang="ts">
import { ref, watch } from 'vue'
import ReportSummaryFindings from './ReportSummaryFindings.vue'
import ReportSummaryImages from './ReportSummaryImages.vue'
import type { ImagesType } from 'Modules/types/generic/image/ImagesType'

interface PropTypes {
  images: ImagesType
  annotations
  loading
}

const props = defineProps<PropTypes>()
const activeTab = ref('findingsTab')

watch(()=>props.images, (): void => {
  if(props.images.incomplete.length>0){
    activeTab.value = 'imagesTab'
  }
})
</script>

<template>
  <el-tabs v-model="activeTab" class="aircraft-list-tabs mx-auto">
    <el-tab-pane label="FINDINGS" name="findingsTab">
      <el-progress v-if="props.loading" :percentage="100" :indeterminate="true" :show-text="false" class="mb-3"/>
      <ReportSummaryFindings :annotations="props.annotations" />
    </el-tab-pane>
    <el-tab-pane label="IMAGES" name="imagesTab">
      <el-progress v-if="props.loading" :percentage="100" :indeterminate="true" :show-text="false" class="mb-3"/>
      <ReportSummaryImages :images="props.images" />
    </el-tab-pane>
  </el-tabs>
</template>
